export default __webpack_public_path__ + "static/media/clubhouse.795c89a7.png";